import { ActionTree } from 'vuex'
import { CounterState, ICounterState } from './state';
import { counterTypes } from './types';

export const counterActions: ActionTree<CounterState, ICounterState> = {
  async [counterTypes.actions.setFeatureFlags]({ commit }, featureFlags) {
    commit(counterTypes.mutations.updateFeatureFlags, featureFlags);
  },

  async [counterTypes.actions.setSites]({ commit }, sites) {
    commit(counterTypes.mutations.updateSites, sites);
  },

  async [counterTypes.actions.setSponsors]({ commit }, sponsors) {
    commit(counterTypes.mutations.updateSponsors, sponsors);
  },

  async [counterTypes.actions.setPrograms]({ commit }, programs) {
    commit(counterTypes.mutations.updatePrograms, programs);
  },

  async [counterTypes.actions.setSiteAppDates]({ commit }, siteAppDates) {
    commit(counterTypes.mutations.updateSiteAppDates, siteAppDates);
  },

  async [counterTypes.actions.setSiteAppNonCongregateMeals]({ commit }, siteAppNonCongregateMeals) {
    commit(counterTypes.mutations.updateSiteAppNonCongregateMeals, siteAppNonCongregateMeals);
  },

  async [counterTypes.actions.setPwaInstalled]({ commit }, pwaInstalled) {
    commit(counterTypes.mutations.updatePwaInstalled, pwaInstalled);
  },

  async [counterTypes.actions.setIsOnline]({ commit }, isOnline) {
    commit(counterTypes.mutations.updateIsOnline, isOnline);
  },

  async [counterTypes.actions.setIsSyncing]({ commit }, isSyncing) {
    commit(counterTypes.mutations.updateIsSyncing, isSyncing);
  },

  async [counterTypes.actions.setSelectedSponsorId]({ commit }, selectedSponsorId) {
    commit(counterTypes.mutations.updateSelectedSponsorId, selectedSponsorId);
  },

  async [counterTypes.actions.setSelectedSiteId]({ commit }, selectedSiteId) {
    commit(counterTypes.mutations.updateSelectedSiteId, selectedSiteId);
  },

  async [counterTypes.actions.setSelectedProgramId]({ commit }, selectedProgramId) {
    commit(counterTypes.mutations.updateSelectedProgramId, selectedProgramId);
  },

  async [counterTypes.actions.setSelectedMealDate]({ commit }, selectedMealDate) {
    commit(counterTypes.mutations.updateSelectedMealDate, selectedMealDate);
  },

  async [counterTypes.actions.setTimeStamp]({ commit }, timeStamp) {
    commit(counterTypes.mutations.updateTimeStamp, timeStamp);
  }
};
